import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { Section } from '@omni/ai/features/card.schema';

/** A `facts` section's items — label/value pairs. */
type FactItem = Extract<Section, { type: 'facts' }>['items'][number];

/**
 * Label / value fact rows. Grid `auto-fit` packs 2-3 columns when wide and
 * collapses to one column on narrow viewports via CSS grid.
 */
@Component({
  selector: 'card-facts',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './card-facts.component.html',
  styleUrls: ['./card-facts.component.scss'],
})
export class CardFactsComponent {
  @Input() title: string | null = null;
  @Input() items: FactItem[] = [];

  trackFact(i: number, item: FactItem): string {
    return i + ':' + item.label;
  }
}
